import { Endpiont } from 'shared/utils/Endpoints';
import { HTTP_CLIENT } from '../../utils/Interceptor';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { toastMessage } from 'shared/components/toast/Toast';

// ------------------ list Rough Listing-------
const getAllRoughListing = async (filter) => {
    const {
        data: { data }
    } = await HTTP_CLIENT.get(Endpiont.roughListing.list + `${filter ? '?' + filter : ''}`);
    return data;
};
const GetAllRoughListingQuery = (filter) => {
    return useQuery(['RoughListinglist', filter], () => getAllRoughListing(filter));
};

// ------------------ Add Rough Listing-------
const addRoughListing = async (payload) => {
    return await HTTP_CLIENT.post(Endpiont.roughListing.add, payload);
};
const AddRoughListingMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(addRoughListing, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('RoughListinglist');
            toastMessage('success', 'Rough Listing Added Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            if (desc) {
                toastMessage('error', desc || 'Server Error');
            }
        }
    });
};

// ------------------ Delete Rough Listing-------
const deleteRoughListing = async (id) => {
    return await HTTP_CLIENT.delete(Endpiont.roughListing.delete + id);
};
const DeleteRoughListingMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(deleteRoughListing, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('RoughListinglist');
            toastMessage('success', 'Rough Listing Deleted Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            if (desc) {
                toastMessage('error', desc || 'Server Error');
            }
        }
    });
};

// ------------------ Assign SKU / Draft -------
const assignSku = async (payload) => {
    return await HTTP_CLIENT.post(Endpiont.roughListing.assignSku, payload);
};
const AssignSkuMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(assignSku, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('RoughListinglist');
            toastMessage('success', 'SKUs Assigned and Saved as Draft!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            if (desc) {
                toastMessage('error', desc || 'Server Error');
            }
        }
    });
};

// ------------------ Update Rough Listing -------
const updateRoughListing = async ({ id, payload }) => {
    return await HTTP_CLIENT.put(Endpiont.roughListing.update + id, payload);
};
const UpdateRoughListingMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(updateRoughListing, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('RoughListinglist');
            toastMessage('success', 'Rough Listing Updated Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc || error?.response?.data?.message;
            if (desc) {
                toastMessage('error', desc || 'Server Error');
            }
        }
    });
};

// ------------------ Create Tasks from Rough Listing -------
const createTasksFromRL = async (id) => {
    return await HTTP_CLIENT.post(Endpiont.roughListing.createTasks + id);
};
const CreateTasksFromRLMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(createTasksFromRL, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('RoughListinglist');
            toastMessage('success', data?.data?.message || 'Tasks Created Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.message || error?.response?.data?.desc;
            toastMessage('error', desc || 'Failed to create tasks');
        }
    });
};

const checkVariantExists = async (payload) => {
    const { data } = await HTTP_CLIENT.post(Endpiont.roughListing.checkVariant, payload);
    return data?.data;
};

export { GetAllRoughListingQuery, AddRoughListingMutation, DeleteRoughListingMutation, AssignSkuMutation, UpdateRoughListingMutation, CreateTasksFromRLMutation, checkVariantExists };
